<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }">
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h5 class="font-web">
              <a @click="gotoMainType" class="mr-5"><a-icon type="arrow-left" /></a>แบบฟอร์มการขอทำงานล่วงเวลา
              <span class="font-web text-danger font-weight-bold">*** หัวหน้างานจะอนุมัติภายในวันที่ 7 ของเดือนถัดไป
                ***</span>
            </h5>
            <p class="ml-20 mt-0 mb-0 font-web">
              เขียนแบบฟอร์มเพื่อส่งคำขอการทำงานล่วงเวลาของท่านให้กับหัวหน้า
            </p>
          </a-col>
        </a-row>
      </template>

      <descInfoOt class="mb-20" />

      <a-card :bordered="true">
        <a-row class="mt-10 mb-20" type="flex" align="middle">
          <a-col :span="24" :xs="24" :sm="24" :md="16" class="col-info">
            
            <h6 class="mt-0 mb-5 font-web">
              <strong>เลือก
                <span class="text-danger">เดือน</span>
                ที่ต้องการขอการทำงานล่วงเวลา</strong>
            </h6>
            <a-month-picker v-model="selectMonth" placeholder="Select Month" :format="monthFormat" @change="onChange"
              class="font-web">
              <span>
                <a-input :disabled="loading" :value="moment(selectMonth).locale('th').format('MMMM YYYY')" />
              </span>
              <span class="font-web" slot="monthCellContentRender" slot-scope="date, locale">{{
                moment(date).locale("th").format("MMMM") }}</span>
            </a-month-picker>
          </a-col>
          <a-col class="mt-10" :span="24" :xs="24" :sm="24" :md="8">
            <!-- summary -->
            <div class="text-right">
              <a-skeleton :loading="loading" active :paragraph="{ rows: 1, width: '80%' }">
                <a-tag class="mr-5 mb-10 f-18 font-web" color="#5C2E7E">x1.5 เท่า = {{ countA }}</a-tag>
                <a-tag class="mr-5 mb-10 f-18 font-web" color="pink">x1 เท่า = {{ countB }}</a-tag>
                <a-tag class="mr-5 mb-10 f-18 font-web" color="#256D85">x3 เท่า = {{ countC }}</a-tag>
              </a-skeleton>
            </div>
          </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="dataOt" :loading="loading" size="small" :pagination="false" bordered
          class="mb-20 font-web">
          <span slot="dayLabel"><a-icon class="mr-5" type="calendar" /> วันที่</span>
          <template slot="dayLabel" slot-scope="text, record">
            <a-badge :count="['holiday', 'wfh', 'seminar'].includes(
              record.configInday.calendar_type
            )
              ? record.configInday.calendar_type
              : ''
              ">
              <p class="font-web mt-0 mb-0 font-bold" :class="{
                'text-danger': ['เสาร์', 'อาทิตย์'].includes(
                  moment(record.valDay).locale('th').format('dddd')
                ),
              }">
                {{ moment(record.valDay).locale("th").format("dddd") }} <br />
                {{ record.dayLabel }}
              </p>
            </a-badge>
          </template>

          <template slot="DetailTable" slot-scope="text, record">
            <!-- responsive zone -->
            <div class="text-show mb-10 mt-10">
              <p class="mt-0 mb-0 font-web">
                {{
                  `${moment(record.valDay).locale("th").format("dddd")} ${record.dayLabel
                  }`
                }}
              </p>
              <p class="f-12 mt-5 mb-0 font-weight-bold font-web">
                เวลาเข้างาน :: {{ `${record.chk_in}` }}
              </p>
              <p class="f-12 mt-0 mb-0 font-weight-bold font-web">
                เวลาออกงาน :: {{ `${record.chk_out}` }}
              </p>
            </div>
            <!-- responsive zone -->

            <div v-if="record.dataOtLogs.length !== 0">
              <a-descriptions v-for="(otlist, index) in record.dataOtLogs" :key="'otlist' + index"
                class="mt-20 mb-20 font-web" size="small" bordered>
                <a-descriptions-item label="สถานะ" :colum="1" :span="3">
                  <a-tag :color="otlist.status === 'wait'
                    ? '#FFA500'
                    : otlist.status === 'chief_approve'
                      ? '#14C38E'
                      : otlist.status === 'hr_approve'
                        ? '#14C38E'
                        : '#FF5D5D'
                    ">
                    {{
                      otlist.status === "chief_approve"
                      ? "Approve"
                      : otlist.status
                    }}
                  </a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="เริ่ม OT">{{
                  moment(otlist.start_time).locale("th").format("LTS")
                }}</a-descriptions-item>
                <a-descriptions-item label="เลิก OT" :span="2">{{
                  moment(otlist.end_time).locale("th").format("LTS")
                }}</a-descriptions-item>
                <a-descriptions-item label="รายละเอียดการทำงาน" :span="3">{{
                  otlist.reason
                }}</a-descriptions-item>
                <a-descriptions-item label="1.5 เท่า">{{
                  otlist.cal_one_point_five
                }}</a-descriptions-item>
                <a-descriptions-item label="1 เท่า">{{
                  otlist.cal_one_point_o
                }}</a-descriptions-item>
                <a-descriptions-item label="3 เท่า">{{
                  otlist.cal_three_point_o
                }}</a-descriptions-item>
                <a-descriptions-item v-if="otlist.status === 'wait'" label="action">
                  <a-popconfirm placement="top" ok-text="ยืนยัน" cancel-text="ยกเลิก" @confirm="confirmDel(otlist)">
                    <template slot="title">
                      <p class="mt-0 mb-0">ยืนยันลบข้อมูลรายการนี้</p>
                    </template>
                    <a-button class="font-web ma-10" type="danger" size="small" icon="delete">
                      ลบคำขอ
                    </a-button>
                  </a-popconfirm>
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </template>

          <template slot="action" slot-scope="text, record">
            <a-button @click="modalFormOt(record, true)" class="font-web" type="primary" size="small" icon="form" v-if="record.chk_in !== record.chk_out &&
              record.chk_in !== '-' &&
              record.chk_out !== '-'
              ">
              เบิกค่าล่วงเวลา
            </a-button>
          </template>
        </a-table>
      </a-card>
    </a-card>

    <!-- modal -->
    <a-modal v-model="visibleRequestOtForm" class="font-web" title="เขียนคำขอทำงานล่วงเวลา" :closable="false">
      <template slot="footer">
        <a-button key="back" @click="modalFormOt({}, false)" class="font-web">
          ปิดหน้าต่าง
        </a-button>
        <!--  
          :disabled="
            objRequest.start_time && objRequest.end_time ? !(moment(objRequest.start_time, 'HH:mm').format('HH:mm') < moment(objRequest.end_time, 'HH:mm').format('HH:mm')) : true
          "
        -->
        <a-button
          key="submit"
          type="primary"
          :loading="loadingBtnModal"
          :disabled="timeValidateMessage !== 'pass'"
          @click="handleOk"
        >
          ส่งคำขอ
        </a-button>
      </template>
      <div v-if="Object.keys(objRequest).length !== 0">
        <!-- info -->
        <a-alert message="ข้อมูลการบันทึกเวลา" type="info" show-icon class="mb-20">
          <span slot="icon"><a-icon type="calendar" /></span>
          <div slot="description">
            <a-row class="mt-10 ma-0">
              <a-col :span="4">
                <p class="mt-0 mb-0">วันที่ :</p>
              </a-col>
              <a-col :span="10" :offset="10" class="text-right">
                <h6 class="font-web font-bold mt-0 mb-0">
                  {{ moment(objRequest.valDay).locale("th").format("dddd") }}
                  {{ objRequest.dayLabel }}
                </h6>
              </a-col>
            </a-row>

            <a-row class="mt-5 ma-0">
              <a-col :span="8">
                <p class="mt-0 mb-0">เวลาเข้างาน :</p>
              </a-col>
              <a-col :span="8" :offset="8" class="text-right">
                <h5 class="text-success mt-0 mb-0">
                  <strong>{{ objRequest.chk_in }}</strong>
                </h5>
              </a-col>
            </a-row>

            <a-row class="mt-5 ma-0">
              <a-col :span="8">
                <p class="mt-0 mb-0">เวลาเลิกงาน :</p>
              </a-col>
              <a-col :span="8" :offset="8" class="text-right">
                <h5 class="text-danger mt-0 mb-0">
                  <strong>{{ objRequest.chk_out }}</strong>
                </h5>
              </a-col>
            </a-row>
          </div>
        </a-alert>
        <!-- ot start -->
        <a-form-item label="เวลาเริ่ม OT" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="" class="font-web">
          <a-time-picker format="HH:mm" v-model="objRequest.start_time" />
        </a-form-item>
        <!-- ot end -->
        <a-form-item label="เวลาเลิก OT" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="" class="font-web">
          <a-time-picker format="HH:mm" v-model="objRequest.end_time" />
        </a-form-item>

        <!-- description -->
        <a-form-item label="รายละเอียดการทำงาน" extra="" class="font-web">
          <a-textarea placeholder="" v-model="objRequest.reason" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
        <!-- error -->
        <div v-if="timeValidateMessage && timeValidateMessage !== 'pass'" class="mb-15">
          <a-alert :message="timeValidateMessage" type="warning" show-icon />
        </div>
        <div v-if="boxErrorOt.length !== 0">
          <a-alert :message="`Error ::`" :description="!['', null, 'null'].includes(boxErrorOt[0].msg)
            ? boxErrorOt[0].msg.split('#').length !== 0
              ? boxErrorOt[0].msg.split('#')[0]
              : ''
            : ''
            " type="error" show-icon />
        </div>
      </div>
    </a-modal>
    <!-- modal -->
  </div>
</template>

<script>
import descInfoOt from "../infoText/ot_desc.vue";
const columns = [
  {
    dataIndex: "dayLabel",
    scopedSlots: {
      customRender: "dayLabel",
    },
    slots: { title: "dayLabel" },
    className: "column-day colum-hide",
  },
  {
    title: "เวลาเข้างาน",
    dataIndex: "chk_in",
    scopedSlots: { customRender: "chk_in" },
    className: "column-time column-in colum-hide",
  },
  {
    title: "เวลาออกงาน",
    dataIndex: "chk_out",
    scopedSlots: { customRender: "chk_out" },
    className: "column-time column-out colum-hide",
  },
  {
    title: "รายละเอียดการขอทำ OT",
    dataIndex: "DetailTable",
    scopedSlots: { customRender: "DetailTable" },
    className: "",
  },
  {
    title: "#",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    className: "column-day",
  },
];
export default {
  components: {
    descInfoOt,
  },
  data() {
    return {
      columns,
      dataDayEvent: [],
      dataOt: [],
      countA: 0,
      countB: 0,
      countC: 0,
      loading: false,
      selectMonth: this.moment().format(),
      monthFormat: "MMMM/YYYY",
      // modal
      objRequest: {},
      loadingBtnModal: false,
      visibleRequestOtForm: false,
      // error msg
      boxErrorOt: [],
    };
  },
  computed: {
    timeValidateMessage() {
      if (!this.objRequest || Object.keys(this.objRequest).length === 0) {
        return "";
      }
      return this.validateTimeRequest(
        this.objRequest.chk_in,
        this.objRequest.chk_out,
        this.objRequest.start_time,
        this.objRequest.end_time
      );
    },
  },
  mounted() {
    this.getListDataOt();
  },
  methods: {
    parseTime(val) {
      if (!val || val === "-" || val === "null" || val === "Invalid date") return null;
      if (this.moment.isMoment(val)) return val.isValid() ? val : null;
      const m = this.moment(val, ["HH:mm:ss", "HH:mm", "kk:mm:ss", "kk:mm"]);
      return m.isValid() ? m : null;
    },
    validateTimeRequest(chkIn, chkOut, startTime, endTime) {
      const start = this.parseTime(startTime);
      const end = this.parseTime(endTime);

      if (!start || !end) {
        return "";
      }

      const startMinutes = start.hours() * 60 + start.minutes();
      const endMinutes = end.hours() * 60 + end.minutes();

      if (endMinutes <= startMinutes) {
        return "เวลาที่ขอไม่สอดคล้องกับข้อมูลการบันทึกเวลาทำงาน";
      }

      const inTime = this.parseTime(chkIn);
      const outTime = this.parseTime(chkOut);

      if (!inTime || !outTime) {
        return "";
      }

      let inMinutes = inTime.hours() * 60 + inTime.minutes() - 15;
      if (inMinutes < 0) inMinutes = 0;

      let outMinutes = outTime.hours() * 60 + outTime.minutes() + 15;
      if (outMinutes > 24 * 60) outMinutes = 24 * 60;

      if (startMinutes < inMinutes || endMinutes > outMinutes) {
        return "เวลาที่ขอไม่สอดคล้องกับข้อมูลการบันทึกเวลาทำงาน";
      }

      return "pass";
    },
    gotoMainType() {
      this.$router
        .push({
          path: "/hri/request",
        })

    },
    async onChange(value, dateString) {
      await this.getListDataOt();
    },
    formatMonth(val) {
      return val.toString().length == 1 ? "0" + val.toString() : val.toString();
    },
    getDayInFirst(month, year) {
      return new Date(year, month, 1).getDate().toString().length == 1
        ? "0" + new Date(year, month, 1).getDate()
        : new Date(year, month, 1).getDate();
    },
    getDayInLast(month, year) {
      return new Date(year, month, 0).getDate().toString().length == 1
        ? "0" + new Date(year, month, 0).getDate()
        : new Date(year, month, 0).getDate();
    },
    async getDaySetting() {
      this.dataDayEvent = [];
      const x = new Date(this.selectMonth);
      let month = Number.parseInt(x.getMonth()) + Number.parseInt(1);
      let year = x.getFullYear();
      let formatMount = this.formatMonth(month);
      let startMonth =
        year + "-" + `${formatMount}` + "-" + this.getDayInFirst(month, year);
      let endMonth =
        year + "-" + formatMount + "-" + this.getDayInLast(month, year);

        const res = await this.$http.get(
          `/hri/calendar_data/?timestart=${startMonth}&timeend=${endMonth}`
        );
        if (res.status === 200) {
          this.dataDayEvent = res.data.map((item) => ({
            ...item,
            type: "error",
            content: item.detail,
          }));
        } else {

          const err = new Error('API Error');
          err.res = res;
          throw err;
        }
    },
    checkDayConfig(day) {
      let resault = [];
      if (this.dataDayEvent.length !== 0) {

        for (const listDconfig of this.dataDayEvent) {
          if (day === listDconfig.extra_date) {
            resault = listDconfig;
          }
        }
      }

      return resault;
    },
    calDataSummary(arrLog) {
      if (arrLog.length != 0) {
        for (const listCal of arrLog) {
          this.countA += listCal.cal_one_point_five;
          this.countB += listCal.cal_one_point_o;
          this.countC += listCal.cal_three_point_o;
        }
      }
    },
    mapOtRecord(record, index) {
      this.calDataSummary(Object.keys(record.ot).length !== 0 ? record.ot : []);

      const log = record.log || {};
      const chk_in = Object.keys(log).length !== 0 ? log.start : "-";
      const chk_out = Object.keys(log).length !== 0
        ? (log.end !== log.start ? log.end : "-")
        : "-";

      return {
        id: index,
        textDay: record.date,
        valDay: record.date,
        dayLabel: this.moment(record.date).locale("th").format("DD MMMM YYYY"),
        chk_in: chk_in,
        chk_out: chk_out,
        start_time: "",
        end_time: "",
        reason: "",
        cal_one_point_five: "",
        cal_one_point_o: "",
        cal_three_point_o: "",
        status: "",
        dataOtLogs: Object.keys(record.ot).length !== 0 ? record.ot : [],
        configInday: this.checkDayConfig(record.date),
      };
    },
    async getListDataOt() {
      this.countA = 0;
      this.countB = 0;
      this.countC = 0;
      this.loading = true;
      this.dataOt = [];

      try {
        if (["", "null", null].includes(this.selectMonth)) {
          this.dataOt = [];
          this.loading = false;
          return;
        }

        await this.getDaySetting();
        let d = this.moment(this.selectMonth);
        let startMonth = d.clone().startOf("month");
        let endMonth = d.clone().endOf("month");

        try {
          const res = await this.$http.get(
            `/hri/ot/me/?timestart=${this.moment(startMonth._d).format("YYYY-MM-DD")}&timeend=${this.moment(endMonth._d).format("YYYY-MM-DD")}`
          );
          if (res.status === 200) {
            this.dataOt = res.data.map((record, i) => this.mapOtRecord(record, i));
          } else {

            const err = new Error('API Error');
            err.res = res;
            throw err;
          }
        } catch (error) {
          const status = error.response ? error.response.status : '';
          this.$notification.open({
            style: {
              backgroundColor: "#ff1919",
              color: "#ffffff",
            },
            message: function (h) {
              return h("div", [
                h("strong", { class: "" }, `Error ${status}`),
              ]);
            },
            description: `Problem issue connect api : /hri/ot/me/?timestart=${this.moment(
              startMonth._d
            ).format("YYYY-MM-DD")}&timeend=${this.moment(endMonth._d).format(
              "YYYY-MM-DD"
            )}`,
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        const status = error.response ? error.response.status : 'Unknown';
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${status}`),
            ]);
          },
          description: `Problem issue connect api : getListDataOt`,
        });
      }
    },
    modalFormOt(item, modalAction) {
      this.boxErrorOt = [];
      this.loadingBtnModal = false;
      this.objRequest = { ...item };
      this.visibleRequestOtForm = modalAction;
    },
    async handleOk(e) {
      this.boxErrorOt = [];
      this.loadingBtnModal = true;
      let arr = [];
      const sendData = new FormData();
      Object.entries(this.objRequest).forEach(([key, value]) => {
        if (["start_time", "end_time"].includes(key)) {
          sendData.append(
            key,
            `${this.moment(this.objRequest.valDay).format(
              "YYYY-MM-DD"
            )} ${this.moment(value, "HH:mm").format("HH:mm")}:00`
          );
        } else if (["reason"].includes(key)) {
          sendData.append(key, value);
        }
      });
      try {
        const response = await this.$http.post(
          "/hri/ot/add_request/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 200) {
          // update slot time
          const index = this.dataOt.findIndex(
            (itemRe) =>
              itemRe.textDay ===
              this.moment(response.data.start_time).format("YYYY-MM-DD")
          );
          this.dataOt[index].dataOtLogs.push(response.data);
          // update slot time

          //update ot amount
          this.countA += response.data.cal_one_point_five
          this.countB += response.data.cal_one_point_o
          this.countC += response.data.cal_three_point_o
          //

          this.loadingBtnModal = false;
          this.visibleRequestOtForm = false;
        } else {

          const err = new Error('API Error');
          err.response = response;
          throw err;
        }
      } catch (error) {
        this.loadingBtnModal = false;
        this.boxErrorOt.push(error.response.data);
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Problem issue connect api : /hri/ot/add_request/`,
        });
      }
    },
    async confirmDel(data) {
      try {
        const res = await this.$http.delete(`/hri/ot/${data.id}/remove/`);
        if (res.status === 200) {
          const index = this.dataOt.findIndex(
            (itemRe) =>
              itemRe.textDay ===
              this.moment(data.check_in_start).format("YYYY-MM-DD")
          );
          const subindex = this.dataOt[index].dataOtLogs.findIndex(
            (itemIn) => itemIn.id === data.id
          );
          //Cal ot amount 
          //update OT amount
          this.countA = this.countA - this.dataOt[index].dataOtLogs[subindex]['cal_one_point_five']
          this.countB = this.countB - this.dataOt[index].dataOtLogs[subindex]['cal_one_point_o']
          this.countC = this.countC - this.dataOt[index].dataOtLogs[subindex]['cal_three_point_o']
          //
          //
          this.dataOt[index].dataOtLogs.splice(subindex, 1);
        } else {

          const err = new Error('API Error');
          err.res = res;
          throw err;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /hri/ot/${data.id}/remove/`,
        });
      }
    },
  },
};
</script>

<style scoped>
.f-12 {
  font-size: 12px;
}
</style>

<style>
th.column-time,
td.column-time {
  text-align: center !important;
  font-weight: 700 !important;
}

th.column-cal,
td.column-cal {
  text-align: center !important;
}

th.column-day,
td.column-day {
  text-align: center !important;
}

th.column-day {
  background-color: #b4cde6 !important;
  color: #000 !important;
}

th.column-in {
  background-color: #b6e388 !important;
  color: #000 !important;
}

th.column-out {
  background-color: #f96666 !important;
  color: #000 !important;
}

.f-18 {
  font-size: 18px;
}

/* css responsive */


.text-show {
  display: none !important;
}

@media screen and (max-width: 600px) {
  .colum-hide {
    display: none !important;
  }

  .text-show {
    display: block !important;
  }
}
</style>